// vendors
import { Fragment, useState } from "react";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import { useSelector } from "react-redux";
import { v4 as uuid } from "uuid";
import parse from "html-react-parser";
// component
import MessagePreview from "../../Components/MessagePreview";
import Editor from "../../Components/Editor";
import Configurations from "./Configurations";

// slice
import {
  getLanguage,
  getActiveNode,
  updateModifiedData,
  setInputValues,
} from "../../Slices/main.slice";
import { useAppDispatch } from "../../../../Store";

// utils
import {
  getResponse,
  getText,
  getInitialEditorText,
  getPlainTextData,
  getHTMLContent,
  cleanMediaDetails,
  getMediaDetails,
} from "../../Utils";
import {
  convertWhatsappToHtmlText,
  getChannelWiseText,
} from "../../Utils/editor";
import { useCurrentBot } from "../../../../Store/Slices/DashboardSlices";

const ImgFileNode = (props: NodeProps) => {
  const { node } = props;
  const { channel } = useSelector(useCurrentBot);
  const language = useSelector(getLanguage);
  const activeNode = useSelector(getActiveNode);
  const response = getResponse(node, language);
  const text = getText(response);
  const media = getMediaDetails(response);
  const [editorState, setEditorState] = useState(
    getInitialEditorText(text || ""),
  );
  const [selectedExtensions, setSelectedExtensions] = useState(
    Array.isArray(node?.response) && node.response.length > 0
      ? node.response[0].allowedFileTypes || []
      : []
  );
  const isActiveNode = activeNode === node.nodeId;
  const dispatch = useAppDispatch();

  const onEditorStateChange = (editorState: any, mediaInfo: any) => {
    setEditorState(editorState);
       dispatch(
      updateModifiedData([
        {
          id: uuid(),
          allowedFileTypes: selectedExtensions,
          value: getChannelWiseText(getHTMLContent(editorState), channel),
          type: "text"
        },
      ]),
    );
  };

  const handleSave = (selectedExt: any) => {
    // Extract extension labels from mixed array of strings and objects
    const extensionLabels = selectedExt.flatMap((item: any) => {
      // If it's a string, return it directly
      if (typeof item === 'string') {
        return item;
      }
      // If it's an object with extensions property, extract labels
      if (item && item.extensions && Array.isArray(item.extensions)) {
        return item.extensions.map((ext: any) => ext.label);
      }
      // Return empty array if neither condition is met
      return [];
    });

    // Replace the entire selectedExtensions state with new selection
    setSelectedExtensions(extensionLabels);
    dispatch(setInputValues({ value: extensionLabels, type: "img-file" }));

    // Immediately update the store with the new extensions and current editor state
    dispatch(
      updateModifiedData([
        {
          id: uuid(),
          allowedFileTypes: extensionLabels,
          value: getChannelWiseText(getHTMLContent(editorState), channel),
          type: "text"
        },
      ]),
    );
  };

  return (
    <>
      <Box p={"8px 16px"}>
        {isActiveNode ? (
          <Editor
            editorState={editorState}
            onEditorStateChange={onEditorStateChange}
            error={getPlainTextData(editorState) === ""}
            mediaInfo={media}
            media={false}
            mediaUpload = {false}
          />
        ) : (
          <MessagePreview
            text={convertWhatsappToHtmlText(text)}
            mediaDetails={media}
          />
        )}
      </Box>
      {isActiveNode && (
        <Fragment>
          <Divider />
          <Box p={"16px"} display={"flex"} justifyContent={"space-between"}>
            <Typography>Allow Extensions</Typography>
            <Configurations
              onSave={handleSave}
              extensions={selectedExtensions || []}
            />
          </Box>
        </Fragment>
      )}
    </>
  );
};
export default ImgFileNode;
